import React from 'react';
import { BarChart3, Loader2 } from 'lucide-react';

const HealthMapTab = ({ ctx }) => {
  const { members, heatmapData } = ctx;

  return (
<div data-testid="health-map-tab">
  <h1 className="text-xl font-bold mb-1" style={{ color: '#1A1209' }}>Team Health Heatmap</h1>
  <p className="text-xs mb-5" style={{ color: '#999' }}>
    Visual overview of department engagement across 8 weeks. Darker = higher engagement. Spot patterns and intervene early.
  </p>

  {heatmapData?.demo_data && (
    <div className="flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-medium mb-4" style={{ backgroundColor: '#EFF6FF', color: '#1E40AF', border: '1px solid #BFDBFE' }}>
      <BarChart3 size={14} />
      Sample data — will reflect real team activity once members are active
    </div>
  )}

  {heatmapData?.heatmap?.length > 0 ? (
    <div className="bg-white rounded-xl p-5 overflow-x-auto" style={{ border: '1px solid #E8E8E8' }} data-testid="heatmap-grid">
      <table className="w-full min-w-[700px]">
        <thead>
          <tr>
            <th className="text-left text-[11px] font-semibold uppercase pb-3 pr-4" style={{ color: '#999', width: '160px' }}>Department</th>
            {heatmapData.weeks.map(w => (
              <th key={w} className="text-center text-[10px] font-semibold pb-3 px-1" style={{ color: '#BBB' }}>{w}</th>
            ))}
            <th className="text-center text-[11px] font-semibold pb-3 pl-3" style={{ color: '#999' }}>Avg</th>
          </tr>
        </thead>
        <tbody>
          {heatmapData.heatmap.map((row, ri) => (
            <tr key={row.department} data-testid={`heatmap-row-${ri}`}>
              <td className="py-1.5 pr-4">
                <span className="text-xs font-bold" style={{ color: '#1A1209' }}>{row.department}</span>
              </td>
              {row.weeks.map((w, wi) => {
                const intensity = Math.round(w.engagement * 255);
                const bg = w.status === 'high' ? `rgba(16, 185, 129, ${0.15 + w.engagement * 0.7})` : w.status === 'medium' ? `rgba(245, 158, 11, ${0.15 + w.engagement * 0.5})` : `rgba(239, 68, 68, ${0.15 + w.engagement * 0.4})`;
                return (
                  <td key={wi} className="py-1.5 px-1">
                    <div className="relative group">
                      <div className="w-full h-10 rounded-md flex items-center justify-center cursor-default transition-transform hover:scale-110" style={{ backgroundColor: bg }}>
                        <span className="text-[9px] font-bold" style={{ color: w.status === 'high' ? '#065F46' : w.status === 'medium' ? '#92400E' : '#991B1B' }}>{Math.round(w.engagement * 100)}%</span>
                      </div>
                      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 px-2 py-1 rounded text-[9px] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10" style={{ backgroundColor: '#1A1209', color: '#E8DDD0' }}>
                        Sentiment: {w.sentiment} | Sessions: {w.sessions}
                      </div>
                    </div>
                  </td>
                );
              })}
              <td className="py-1.5 pl-3 text-center">
                <span className="text-sm font-black" style={{ color: row.avg_engagement >= 0.7 ? '#059669' : row.avg_engagement >= 0.4 ? '#F59E0B' : '#DC2626' }}>
                  {Math.round(row.avg_engagement * 100)}%
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex items-center justify-center gap-6 mt-5 pt-4" style={{ borderTop: '1px solid #F0F0F0' }}>
        {[{ label: 'High (70%+)', color: 'rgba(16,185,129,0.5)' }, { label: 'Medium (40-69%)', color: 'rgba(245,158,11,0.4)' }, { label: 'Low (<40%)', color: 'rgba(239,68,68,0.35)' }].map(l => (
          <div key={l.label} className="flex items-center gap-2">
            <div className="w-5 h-4 rounded" style={{ backgroundColor: l.color }} />
            <span className="text-[10px]" style={{ color: '#999' }}>{l.label}</span>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <div className="bg-white rounded-xl p-8 text-center" style={{ border: '1px solid #E8E8E8' }}>
      <Loader2 size={24} className="animate-spin mx-auto mb-3" style={{ color: '#DDD' }} />
      <p className="text-sm" style={{ color: '#999' }}>Loading health map...</p>
    </div>
  )}
</div>
  );
};

export default HealthMapTab;
